export default "__VITE_ASSET__Bb6CTX3R__"